import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig.js";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

const deleteGoogleCalendarEvent = async (event_id, token, prefix) => {
  // Define the endpoint URL for your Python backend
  const url = prefix + `events/${event_id}`;

  // Define the request body

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the PUT request to modify the event
    const response = await fetch(url, {
      method: "DELETE",
      headers: headers,
    });

    let responseData = await response.json();

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");
    let end = new Date();
    let elapsed = end - start;
    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      eventref_id, // event reference ID
      "", // docid (optional)
      {},
      JSON.stringify(responseData), // response data as string
      "DELETE",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      return responseData;
    } else {
      console.error(`Failed to modify event: ${response.status}`);
      return `Failed to modify event: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default deleteGoogleCalendarEvent;
